import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';

const HomeScreen = ({ backgroundImage, withoutTg }) => {
  return (
    <div className={styles.container}>
      <div className={styles.content} style={{ backgroundImage }}>
        <img
          className={styles.headGif}
          src={getImageFromS3('images/brand-ed-prl3/factory.png')}
          alt="factory-gif"
        />
        <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginTop: '-50px' }}>
          <rect width="76" height="76" rx="38" fill="#182F5F"/>
          <path d="M35.7598 15C36.099 15 36.374 15.275 36.374 15.6143V20.5918H40.2217C40.5608 20.5918 40.8368 20.8669 40.8369 21.2061V22.6553H44.3779C44.7171 22.6553 44.9921 22.9304 44.9922 23.2695V27.4824H47.4746V25.6426C47.4748 25.3036 47.7499 25.0294 48.0889 25.0293H52.9727V18.4414H38.3369C37.998 18.4411 37.7238 18.1661 37.7236 17.8271C37.7236 17.4881 37.9979 17.2132 38.3369 17.2129H53.5869C53.926 17.2131 54.2002 17.488 54.2002 17.8271V61.0664C54.2001 61.4055 53.9259 61.6805 53.5869 61.6807H22.6143C22.2751 61.6806 22.0001 61.4055 22 61.0664V17.8271C22 17.4879 22.275 17.2129 22.6143 17.2129H28.7354C29.0745 17.213 29.3496 17.488 29.3496 17.8271C29.3494 18.1662 29.0744 18.4413 28.7354 18.4414H23.2285V25.0293H25.9189V23.2695C25.919 22.9303 26.194 22.6553 26.5332 22.6553H30.4834V15.6143C30.4834 15.2751 30.7585 15.0001 31.0977 15H35.7598ZM23.2285 60.4521H52.9727V39.3994H23.2285V60.4521ZM23.2285 38.1709H52.9727V26.2568H48.7031V36.0361C48.7031 36.3754 48.4281 36.6504 48.0889 36.6504H27.6631C27.324 36.6502 27.0488 36.3753 27.0488 36.0361V26.2568H23.2285V38.1709ZM27.1475 25.0293H27.6631C28.0022 25.0293 28.2771 25.3035 28.2773 25.6426V35.4219H30.4834V23.8838H27.1475V25.0293ZM31.7119 35.4219H35.1455V21.2754C35.1455 21.2636 35.1478 21.2519 35.1484 21.2402C35.1478 21.229 35.1455 21.2175 35.1455 21.2061V16.2285H31.7119V35.4219ZM36.374 35.4219H39.5059V21.8203H36.374V35.4219ZM44.9922 35.4219H47.4746V28.7109H44.9922V35.4219ZM40.7344 35.4219H43.7637V23.8838H40.7344V35.4219Z" fill="white"/>
        </svg>
        <p className={styles.headTitle}>
          Подивись, яка<br /> у нас пачка!
        </p>
        <p className={styles.headDescription}>
          Наприклад, лінійка <b>Parliament Кінг Сайз Стандарт</b> вироблена на власній фабриці в Україні за всіма стандартами якості.
        </p>
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="path-1-inside-1_797_230" fill="white">
            <path d="M13.5459 0L27.0918 13.5459L13.5459 27.0918L-2.42636e-05 13.5459L13.5459 0Z"/>
          </mask>
          <path d="M13.5459 27.0918L12.8388 27.799L13.5459 28.5061L14.253 27.799L13.5459 27.0918ZM27.0918 13.5459L26.3847 12.8388L12.8388 26.3847L13.5459 27.0918L14.253 27.799L27.7989 14.253L27.0918 13.5459ZM13.5459 27.0918L14.253 26.3847L0.707083 12.8388L-2.42636e-05 13.5459L-0.707131 14.253L12.8388 27.799L13.5459 27.0918Z" fill="white" mask="url(#path-1-inside-1_797_230)"/>
          <mask id="path-3-inside-2_797_230" fill="white">
            <path d="M13.5459 4L21.0459 11.5L13.5459 18.9999L6.04593 11.5L13.5459 4Z"/>
          </mask>
          <path d="M13.5459 18.9999L12.8388 19.707L13.5459 20.4141L14.253 19.707L13.5459 18.9999ZM21.0459 11.5L20.3388 10.7929L12.8388 18.2928L13.5459 18.9999L14.253 19.707L21.753 12.2071L21.0459 11.5ZM13.5459 18.9999L14.253 18.2928L6.75304 10.7929L6.04593 11.5L5.33883 12.2071L12.8388 19.707L13.5459 18.9999Z" fill="white" mask="url(#path-3-inside-2_797_230)"/>
        </svg>
        <div className={styles.packagingContainer}>
          <div className={styles.packagingContent}>
            <img
              className={styles.packImage}
              src={getImageFromS3('images/brand-ed-prl3/pack.png')}
              alt="pack"
            />
            <p className={styles.packTitle}>Кожна пачка <b>Parliament Кінг Сайз Стандарт*</b> має особливі відмінні елементи пакування</p>
            <p className={styles.disclaimerTitle}>*якщо термін тобі все ще не знайомий – радимо повернутись на попереднє повідомлення та ознайомитись з <b>Форматами</b>😉</p>
            <div className={styles.elementBg} />
            <img
              className={styles.groupedShadow}
              src={getImageFromS3('images/brand-ed-prl1/groupedShadow.png')}
              alt="groupedShadow"
            />
          </div>
        </div>
        <div className={styles.packsContainer}>
          <p className={styles.packRequirements}>Вимоги до упакування також регулюються законом, тому нижче ти знайдеш відповіді на запитання: «Куди поділась тарність?» та «Звідки на пачці ці картинки?».</p>
          <div className={styles.developmentContent}>
            <p className={styles.developmentTitle}>Виготовлені в Україні:</p>
            <div className={styles.elementBg} />
            <img
              className={styles.groupedShadow}
              src={getImageFromS3('images/brand-ed-prl1/groupedShadow.png')}
              alt="groupedShadow"
            />
            <img
              className={styles.packsImage}
              src={getImageFromS3('images/brand-ed-prl3/parliament-packs.png')}
              alt="packs"
            />
            <div className={styles.characteristicList}>
              <span className={styles.characteristicItem}>9 мг</span>
              <span className={styles.characteristicItem}>6 мг</span>
              <span className={styles.characteristicItem}>4 мг</span>
              <span className={styles.characteristicItem}>1 мг</span>
            </div>
            <p className={styles.characteristicTitle}>9 мг, 6 мг, 4 мг, 1 мг — це тарність цигарок. Тобто вміст смол у сигареті, у мг. </p>
          </div>
        </div>
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask id="path-1-inside-1_136_1297" fill="white">
            <path d="M13.5459 0L27.0918 13.5459L13.5459 27.0918L-2.42636e-05 13.5459L13.5459 0Z" />
          </mask>
          <path
            d="M13.5459 27.0918L12.8388 27.799L13.5459 28.5061L14.253 27.799L13.5459 27.0918ZM27.0918 13.5459L26.3847 12.8388L12.8388 26.3847L13.5459 27.0918L14.253 27.799L27.7989 14.253L27.0918 13.5459ZM13.5459 27.0918L14.253 26.3847L0.707083 12.8388L-2.42636e-05 13.5459L-0.707131 14.253L12.8388 27.799L13.5459 27.0918Z"
            fill="white"
            mask="url(#path-1-inside-1_136_1297)"
          />
          <mask id="path-3-inside-2_136_1297" fill="white">
            <path d="M13.5459 4L21.0459 11.5L13.5459 18.9999L6.04593 11.5L13.5459 4Z" />
          </mask>
          <path
            d="M13.5459 18.9999L12.8388 19.707L13.5459 20.4141L14.253 19.707L13.5459 18.9999ZM21.0459 11.5L20.3388 10.7929L12.8388 18.2928L13.5459 18.9999L14.253 19.707L21.753 12.2071L21.0459 11.5ZM13.5459 18.9999L14.253 18.2928L6.75304 10.7929L6.04593 11.5L5.33883 12.2071L12.8388 19.707L13.5459 18.9999Z"
            fill="white"
            mask="url(#path-3-inside-2_136_1297)"
          />
        </svg>
        <div className={styles.warningPacksText}>
          <p>
            Раніше цифра, яка позначає тарність, була розташована на боковій стороні пачки.<br /><br />
            Однак, наразі законодавством заборонено розміщувати інформацію про вміст смоли та нікотину на пачці або самих тютюнових виробах.<br /><br />
            <b>Картинки, що ти бачиш на пачці, — це медичні попередження.</b><br /><br />
            На кожній пачці є три попередження: загальне, комбіноване, а також інформаційне повідомлення.<br /><br />
            <b>Комбіноване медичне попередження</b> супроводжується відповідною кольоровою ілюстрацією разом із інформаційним повідомленням.
          </p>
          <div className={styles.warningSubTitleContainer}>
            <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.09619 6.62946V3.66731C5.09619 3.4336 5.28445 3.24414 5.51668 3.24414C5.7489 3.24414 5.93716 3.4336 5.93716 3.66731V6.62946C5.93716 6.86317 5.7489 7.05263 5.51668 7.05263C5.28445 7.05263 5.09619 6.86317 5.09619 6.62946Z" fill="white"/>
              <path d="M10.187 4.13576C10.187 3.65088 9.93188 3.20759 9.51498 2.96069L6.18808 1.02737C5.76731 0.785543 5.25417 0.786694 4.8412 1.02663L4.84118 1.02661L1.51298 2.96069C1.09672 3.20722 0.840973 3.65577 0.840971 4.13576V7.99501C0.840971 8.47464 1.08999 8.91495 1.49169 9.15746L1.51094 9.16886L1.51097 9.16888L4.8403 11.1036C5.261 11.3452 5.77393 11.344 6.18677 11.1041L9.51496 9.17004C9.93123 8.92351 10.187 8.47499 10.187 7.99501V4.13576ZM11.028 7.99501C11.028 8.77859 10.6112 9.5034 9.94028 9.90018C9.93936 9.90072 9.93844 9.90126 9.93752 9.9018L6.60727 11.8371L6.60724 11.8371C5.93266 12.229 5.10039 12.2279 4.42236 11.838C4.42181 11.8377 4.42125 11.8374 4.4207 11.8371L1.09044 9.9018V9.90178C0.415784 9.50979 0 8.78288 0 7.99501V4.13576C2.13247e-06 3.35218 0.416729 2.62737 1.08768 2.23059L1.09044 2.22897L4.4207 0.293694L4.42073 0.293661C5.09005 -0.0952094 5.9146 -0.0971847 6.58971 0.283661L6.60563 0.292736L6.60727 0.293694L9.93752 2.22897L9.94028 2.23059C10.6106 2.62699 11.028 3.34579 11.028 4.13576V7.99501Z" fill="white"/>
              <path d="M4.95605 8.49173V8.43531C4.95605 8.1237 5.20706 7.87109 5.5167 7.87109C5.82633 7.87109 6.07734 8.1237 6.07734 8.43531V8.49173C6.07734 8.80334 5.82633 9.05596 5.5167 9.05596C5.20706 9.05596 4.95605 8.80334 4.95605 8.49173Z" fill="white"/>
            </svg>
            <p>Якщо у тебе виникли питання або сумніви щодо продукту, будь ласка, повідом нам про це💬</p>
          </div>
        </div>
        <div className={styles.feedbackContainer}>
          <div className={styles.feedbackContent}>
            <div className={styles.elementBg} />
            <img
              className={styles.groupedShadow}
              src={getImageFromS3('images/brand-ed-prl1/groupedShadow.png')}
              alt="groupedShadow"
            />
            <p className={styles.feedbackTitle}>Залишити відгук про продукт можна:</p>
            <ul className={styles.opportunitiesList}>
              <li>За <b>QR-кодом</b></li>
              <li>У Телеграм-боті{' '}<b>Mr.Philip</b></li>
              <li>У опитуванні про продукт</li>
              <li>Через поштову скриньку вказану всередині пачки</li>
            </ul>
            <img
              className={styles.reviewImage}
              src={getImageFromS3('images/brand-ed-prl3/review.png')}
              alt="review"
            />
          </div>
          {!withoutTg && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <mask id="path-1-inside-1_365_88" fill="white">
                <path d="M13.5459 0L27.0918 13.5459L13.5459 27.0918L-2.42636e-05 13.5459L13.5459 0Z" />
              </mask>
              <path
                d="M13.5459 27.0918L12.8388 27.799L13.5459 28.5061L14.253 27.799L13.5459 27.0918ZM27.0918 13.5459L26.3847 12.8388L12.8388 26.3847L13.5459 27.0918L14.253 27.799L27.7989 14.253L27.0918 13.5459ZM13.5459 27.0918L14.253 26.3847L0.707083 12.8388L-2.42636e-05 13.5459L-0.707131 14.253L12.8388 27.799L13.5459 27.0918Z"
                fill="white"
                mask="url(#path-1-inside-1_365_88)"
              />
              <mask id="path-3-inside-2_365_88" fill="white">
                <path d="M13.5459 4L21.0459 11.5L13.5459 18.9999L6.04593 11.5L13.5459 4Z" />
              </mask>
              <path
                d="M13.5459 18.9999L12.8388 19.707L13.5459 20.4141L14.253 19.707L13.5459 18.9999ZM21.0459 11.5L20.3388 10.7929L12.8388 18.2928L13.5459 18.9999L14.253 19.707L21.753 12.2071L21.0459 11.5ZM13.5459 18.9999L14.253 18.2928L6.75304 10.7929L6.04593 11.5L5.33883 12.2071L12.8388 19.707L13.5459 18.9999Z"
                fill="white"
                mask="url(#path-3-inside-2_365_88)"
              />
            </svg>
          )}
        </div>
        {!withoutTg && (
          <>
            <div className={styles.telegramContainer}>
              <p>У Телеграм-боті Mr.Philip кожен продукт Parliament має свій розділ із усіма деталями про тарність, фільтр, формат та інші характеристики.</p>
              <div className={styles.button} onClick={() => window.open('https://t.me/pmu_support_bot?start=catalogue', '_blank')}>
                <img
                  className={styles.glassButton}
                  src={getImageFromS3('images/brand-ed-prl1/glassButton.png')}
                  alt="glassButton"
                />
                Перейти у Telegram
              </div>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <mask id="path-1-inside-1_143_1341" fill="white">
                <path d="M13.5459 27.0918L2.45619e-05 13.5459L13.5459 1.52492e-06L27.0919 13.5459L13.5459 27.0918Z" />
              </mask>
              <path
                d="M13.5459 1.52492e-06L14.2531 -0.707105L13.5459 -1.41421L12.8388 -0.707105L13.5459 1.52492e-06ZM2.45619e-05 13.5459L0.707131 14.253L14.2531 0.707108L13.5459 1.52492e-06L12.8388 -0.707105L-0.707082 12.8388L2.45619e-05 13.5459ZM13.5459 1.52492e-06L12.8388 0.707108L26.3848 14.253L27.0919 13.5459L27.799 12.8388L14.2531 -0.707105L13.5459 1.52492e-06Z"
                fill="white"
                mask="url(#path-1-inside-1_143_1341)"
              />
              <mask id="path-3-inside-2_143_1341" fill="white">
                <path d="M13.5459 23.0918L6.04598 15.5919L13.5459 8.09192L21.0459 15.5919L13.5459 23.0918Z" />
              </mask>
              <path
                d="M13.5459 8.09192L14.2531 7.38481L13.5459 6.67771L12.8388 7.38481L13.5459 8.09192ZM6.04598 15.5919L6.75309 16.299L14.2531 8.79903L13.5459 8.09192L12.8388 7.38481L5.33888 14.8848L6.04598 15.5919ZM13.5459 8.09192L12.8388 8.79903L20.3388 16.299L21.0459 15.5919L21.753 14.8848L14.2531 7.38481L13.5459 8.09192Z"
                fill="white"
                mask="url(#path-3-inside-2_143_1341)"
              />
            </svg>
          </>
        )}
      </div>
      <div className={styles.footer}>
        Куріння викликає<br />серйозні<br />захворювання та<br />залежність<br />Дана інформація<br />про продукт<br />надається<br />відповідно<br />до статті 15 Закону<br />України «Про захист<br />прав споживачів»
      </div>
    </div>
  );
};

export default HomeScreen;
